import { Checkbox, TableCell } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { useLocation } from 'react-router'
import { isAdmin, isDealer } from '../../../../services/AccountService'
import checkboxStore from '../../../../stores/CheckboxStore'
import store from './RequestsTableOptimizedStore'

function HeadCheckbox() {
  const { pathname } = useLocation()
  const isReport = isDealer() && pathname.startsWith('/reports')
  const isRequestsAndAdmin = isAdmin() && pathname === '/requests'
  const disableDealerReportActions = isReport && store?.data?.length === 1
  const { allSelectedCheckbox } = store
  const { isIndeterminate, isAllChecked } = checkboxStore

  const onSelect = () => {
    allSelectedCheckbox(isReport, isRequestsAndAdmin)
  }

  return (
    <TableCell sx={{ padding: '8px' }}>
      <Checkbox
        checked={isAllChecked}
        indeterminate={isIndeterminate}
        onClick={!disableDealerReportActions && onSelect}
        sx={{ opacity: disableDealerReportActions ? '.3' : 1 }}
      />
    </TableCell>
  )
}

export default observer(HeadCheckbox)
